var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6213_11618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 2.91797H3.49967C3.19026 2.91797 2.89351 3.04089 2.67472 3.25968C2.45592 3.47847 2.33301 3.77522 2.33301 4.08464V11.0846C2.33301 11.3941 2.45592 11.6908 2.67472 11.9096C2.89351 12.1284 3.19026 12.2513 3.49967 12.2513H6.82292",
    stroke: "#2081C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.16797V10.5013H12.8333",
    stroke: "#2081C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 6.41797V4.08464C10.5003 3.77522 10.3774 3.47847 10.1586 3.25968C9.93982 3.04089 9.64308 2.91797 9.33366 2.91797H8.16699",
    stroke: "#2081C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 1.75H5.83366C5.18933 1.75 4.66699 2.27233 4.66699 2.91667C4.66699 3.561 5.18933 4.08333 5.83366 4.08333H7.00033C7.64466 4.08333 8.16699 3.561 8.16699 2.91667C8.16699 2.27233 7.64466 1.75 7.00033 1.75Z",
    stroke: "#2081C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 12.8346C11.789 12.8346 12.8337 11.79 12.8337 10.5013C12.8337 9.21264 11.789 8.16797 10.5003 8.16797C9.21166 8.16797 8.16699 9.21264 8.16699 10.5013C8.16699 11.79 9.21166 12.8346 10.5003 12.8346Z",
    stroke: "#2081C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 6.41797H7.00033",
    stroke: "#2081C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 8.75H6.41699",
    stroke: "#2081C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6213_11618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.be157f3fb91b1210748ba794d6ce7648.svg";
export { ForwardRef as ReactComponent };